const common = {
  nav_home: 'Home',
  nav_services: 'Services',
  nav_guide: 'Guide',
  nav_verify: 'Verify',
  nav_hash_tools: 'Hash Tools',
  nav_user_center: 'User Center',
  nav_login: 'Login / Register',
  lang_zh: '中文',
  lang_en: 'English',

  // Hero Section
  hero_badge: 'Trusted Notarization Platform on Polygon Blockchain',
  hero_title_line1: 'On-Chain Rights',
  hero_title_line2: 'Trusted Proof',
  hero_subtitle: 'Give every creation and every right an immutable on-chain certificate',
  hero_subtitle_tags: 'Secure Custody · Withdraw Anytime · Permanent Verification',
  hero_btn_register: 'Start Registration',
  hero_btn_verify: 'On-Chain Query',
  hero_stat_registered: 'On-Chain Records',
  hero_stat_security: 'Security Rate',
  hero_stat_verify: 'Always Verify',

  // Services Section
  services_title: 'Our Services',
  services_subtitle: 'Comprehensive protection for your digital rights',
  service_1_title: 'Immutable On-Chain Proof',
  service_1_desc: 'Based on Polygon blockchain, every registration is permanently stored with a verifiable timestamp',
  service_2_title: 'Multi-Format File Support',
  service_2_desc: 'Supports images, audio/video, documents and more. File hash is on-chain, original file stored securely',
  service_3_title: 'Platform or Self Custody',
  service_3_desc: 'Choose secure platform custody or transfer directly to your digital wallet — flexible and in your control',
  service_4_title: 'Publicly Verifiable',
  service_4_desc: 'Anyone can verify on-chain records through the query page without platform involvement',

  // Scenarios Section
  scenarios_title: 'Applicable to Various Rights Scenarios',
  scenarios_subtitle: 'Whatever type of rights you need to protect, we provide reliable on-chain notarization services',
  scenario_1: 'Copyright / Work Registration',
  scenario_2: 'Certificate / Credential Proof',
  scenario_3: 'Collection / Asset Proof',
  scenario_4: 'Authorization Agreement Proof',
  scenario_5: 'Personal Statement / Fact Declaration',

  // How It Works Section
  how_title: '3 Steps to On-Chain Proof',
  how_subtitle: 'Simple and fast process to make rights protection accessible',
  how_step1_title: 'Upload File',
  how_step1_subtitle: 'Compute Hash',
  how_step1_desc: 'Upload the file you need to notarize. The system automatically computes the file hash to ensure data integrity',
  how_step2_title: 'Payment',
  how_step2_subtitle: 'Mint NFT',
  how_step2_desc: 'After payment, the system mints a unique NFT on the Polygon chain to permanently record your rights',
  how_step3_title: 'On-Chain Verification',
  how_step3_subtitle: 'Permanent Proof',
  how_step3_desc: 'Once minted, anyone can verify your rights record through a blockchain explorer',

  // Compliance Section
  compliance_title: 'Transparent & Compliant Service',
  compliance_subtitle: 'We are committed to providing professional, trustworthy and compliant blockchain notarization services',
  compliance_1: 'On-chain fact verification, permanently queryable',
  compliance_2: 'We do not store original files (hash only)',
  compliance_3: 'We do not provide legal ownership determination',
  compliance_4: 'Compliant with blockchain notarization technical standards',
  compliance_notice_title: 'Important Notice',
  compliance_notice_desc: 'This platform provides technical notarization services and does not constitute legal ownership determination or government registration. We only provide data notarization and verification services based on blockchain technology, and make no judgment or guarantee on the authenticity, legality or ownership of the notarized content. For legal validity, please consult a professional legal institution.',

  // Testimonial Section
  testimonial_label: 'User Reviews',
  testimonial_quote: 'I used RightChain to notarize my photography works on-chain, and the query and verification process is very convenient. Now every photo has an immutable timestamp proof, giving me more confidence in copyright protection.',
  testimonial_name: 'Zhang Li',
  testimonial_role: 'Independent Photographer',
  testimonial_stat1_value: '10,000+',
  testimonial_stat1_label: 'NFTs Registered',
  testimonial_stat2_value: '5,000+',
  testimonial_stat2_label: 'Active Users',
  testimonial_stat3_value: '50,000+',
  testimonial_stat3_label: 'On-Chain Transactions',

  // CTA Section
  cta_title: 'Ready to Protect Your Digital Rights?',
  cta_subtitle: 'Start using RightChain now to create immutable on-chain proof for your works, certificates and assets',
  cta_btn_register: 'Start Registration',
  cta_btn_verify: 'Free Query',
  cta_trust1_title: 'Secure & Reliable',
  cta_trust1_desc: 'Based on Polygon Blockchain',
  cta_trust2_title: 'Fast & Easy',
  cta_trust2_desc: 'Complete in 3 minutes',
  cta_trust3_title: 'Professional Support',
  cta_trust3_desc: '7×24 Online Service',

  // Footer
  footer_desc: 'NFT rights notarization and verification platform based on blockchain, giving every right an on-chain proof.',
  footer_services: 'Services',
  footer_service_1: 'NFT Registration',
  footer_service_2: 'On-Chain Query',
  footer_service_3: 'Rights Withdrawal',
  footer_service_4: 'Batch Operations',
  footer_legal: 'Legal',
  footer_legal_1: 'Terms of Service',
  footer_legal_2: 'Privacy Policy',
  footer_legal_3: 'Compliance Statement',
  footer_legal_4: 'Disclaimer',
  footer_contact: 'Contact Us',
  footer_contact_service: 'Online Support',
  footer_contact_docs: 'Help Docs',
  footer_copyright: '© 2024 RightChain. All rights reserved.',

  // Verify Page
  verify: {
    title: 'NFT Verification',
    subtitle: 'Enter NFT ID or scan QR code to verify authenticity',
    inputLabel: 'Enter NFT ID or Certificate Number',
    inputPlaceholder: 'Enter NFT ID',
    verifyButton: 'Verify',
    scanQR: 'Scan QR Code',
    verifying: 'Verifying...',
    verified: 'Verified',
    notFound: 'Not Found',
    error: 'Verification Failed',
    errorFailed: 'Verification failed, please try again later',
    nftNotFound: 'NFT Not Found',
    tryAgain: 'Please check the ID and try again',
    infoTitle: 'How to find your NFT ID?',
    info1: 'You can find the NFT ID in the certificate or email received after registration',
    info2: 'You can also view the NFT ID in the registration records in your user center',
    info3: 'If you have any questions, please contact our customer support for help',
  },

  // NFT Detail Page
  nftDetail: {
    title: 'NFT Details',
    basicInfo: 'Basic Information',
    nftId: 'NFT ID',
    productName: 'Product Name',
    category: 'Category',
    registrationDate: 'Registration Date',
    status: 'Status',
    description: 'Description',
    ownerInfo: 'Owner Information',
    ownerName: 'Owner Name',
    contactInfo: 'Contact Info',
    blockchainInfo: 'Blockchain Information',
    contractAddress: 'Contract Address',
    tokenId: 'Token ID',
    network: 'Network',
    viewOnBlockscout: 'View on Blockscout',
    viewOnPolygonScan: 'View on PolygonScan',
    queryMore: 'Query More',
    loading: 'Loading...',
    notFound: 'NFT Not Found',
    backToHome: 'Back to Home',
  },

  // Register NFT
  registerNft: {
    title: 'Register NFT',
    steps: {
      basic: 'Basic Info',
      owner: 'Owner Info',
      wallet: 'Wallet',
      payment: 'Payment',
      complete: 'Complete'
    },
    basicInfo: {
      title: 'Basic Information',
      subtitle: 'Please fill in the basic information of the item you want to register',
      itemName: 'Item Name',
      itemNamePlaceholder: 'Enter item name',
      itemNameHint: 'Please provide the accurate item name for future queries and verification',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      categories: {
        electronics: 'Electronics',
        jewelry: 'Jewelry',
        artwork: 'Artwork',
        collectibles: 'Collectibles',
        documents: 'Documents',
        other: 'Other'
      },
      description: 'Description',
      descriptionPlaceholder: 'Describe the characteristics and purpose of the item in detail',
      descriptionHint: 'A detailed description helps prove your rights. At least 50 characters recommended.',
      fileType: 'File Type',
      fileTypeFile: 'Upload File',
      fileTypeHash: 'Enter Hash',
      uploadFile: 'Upload File',
      uploadFileHint: 'Click or drag file here to upload',
      supportedFormats: 'Supports PNG, JPG, PDF, DOC, TXT formats',
      fileSizeLimit: 'Max file size: 10MB',
      uploading: 'Uploading...',
      fileUploaded: 'Upload Successful',
      reselect: 'Reselect',
      fileHash: 'File Hash (SHA-256)',
      fileHashHint: 'Enter the SHA-256 hash of your file. You can use the Hash Tool to compute it.',
      uploadCover: 'Upload Cover Image (Optional)',
      uploadCoverHint: 'Click or drag cover image here to upload',
      coverSizeLimit: 'Max cover image size: 5MB',
      coverUploaded: 'Cover Uploaded Successfully',
      helpTitle: 'Registration Notes',
      helpItem1: 'Please ensure you are the legitimate rights holder of the file. The platform is not responsible for content authenticity.',
      helpItem2: 'The file hash will be permanently recorded on the blockchain. Please confirm the file content is correct.',
      helpItem3: 'Registration cannot be modified after completion. Please review all information carefully.',
      uploadPhotos: 'Upload Photos',
      uploadHint: 'Upload up to 5 photos, JPG and PNG formats supported',
      uploadButton: 'Click to Upload',
      next: 'Next'
    },
    ownerInfo: {
      title: 'Owner Information',
      subtitle: 'Please fill in the detailed information of the item owner',
      currentUser: 'Current User',
      loading: 'Loading...',
      noteLabel: 'Note: ',
      noteContent: 'The registrant will be automatically linked to your account. All rights belong to the currently logged-in user.',
      templateLabel: 'Declaration Template: ',
      templateContent: 'I confirm that I have legitimate rights to the registered item and agree to register it on the blockchain for permanent notarization. I commit that all provided information is true and valid, and I bear corresponding legal responsibility.',
      useTemplate: 'Use This Template',
      registrantInfo: 'Registrant Info (Optional)',
      registrantInfoHint: 'Fill in agent or contact information if needed',
      declaration: 'Rights Declaration (Optional)',
      declarationPlaceholder: 'Please describe your rights to this item and your relationship with it',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter full name',
      idNumber: 'ID Number',
      idNumberPlaceholder: 'Enter ID number',
      phone: 'Phone',
      phonePlaceholder: 'Enter phone number',
      email: 'Email',
      emailPlaceholder: 'Enter email address',
      address: 'Address',
      addressPlaceholder: 'Enter detailed address',
      previous: 'Previous',
      next: 'Next'
    },
    wallet: {
      title: 'Wallet Address',
      subtitle: 'Please provide your blockchain wallet address to receive the NFT',
      walletAddress: 'Wallet Address',
      walletAddressPlaceholder: 'Enter Polygon wallet address (0x...)',
      hint: 'Please ensure the address is correct, NFT will be sent to this address',
      connectWallet: 'Connect Wallet',
      walletConnected: 'Wallet Connected',
      platformCustody: 'Platform Custody',
      recommended: 'Recommended',
      platformCustodyDescription: 'We securely store your NFT on the platform. You can withdraw it to your personal wallet at any time.',
      secureCustody: 'Secure Custody',
      anytimeWithdrawal: 'Withdraw Anytime',
      anytimeWithdrawalDescription: 'You can initiate a withdrawal to your personal wallet at any time, with no restrictions.',
      simpleOperation: 'Easy to Use',
      platformAdvantages: 'Platform Custody Advantages',
      security: 'Bank-Level Security',
      securityDescription: 'Multi-layer encryption and cold storage to ensure your NFT assets are safe.',
      saveCost: 'Save on Gas Fees',
      saveCostDescription: 'No need to pay gas fees yourself; the platform handles all on-chain operations.',
      convenientManagement: 'Convenient Management',
      convenientManagementDescription: 'Manage all your NFTs in the user center with ease.',
      custodyNotice: 'Custody Notice:',
      nftStored: 'Your NFT will be securely stored in the platform\'s custody wallet',
      fullOwnership: 'You retain full ownership of the NFT at all times',
      viewManage: 'You can view and manage your NFT in the user center',
      withdrawToWallet: 'You can withdraw the NFT to your personal wallet at any time',
      previous: 'Previous',
      next: 'Next'
    },
    payment: {
      title: 'Payment',
      subtitle: 'Please complete the payment to continue the registration process',
      orderSummary: 'Order Summary',
      registrationName: 'Registration Name',
      registrationType: 'Registration Type',
      custodyMethod: 'Custody Method',
      platformCustody: 'Platform Custody',
      directTransfer: 'Direct Transfer',
      creator: 'Creator',
      notFilled: 'Not Filled',
      notSelected: 'Not Selected',
      priceBreakdown: 'Price Breakdown',
      serviceFee: 'Platform Service Fee',
      free: 'Free',
      totalAmount: 'Total Amount',
      paymentMethodLabel: 'Payment Method',
      supportedPayments: 'Supported Payment Methods:',
      creditCard: 'Credit Card',
      debitCard: 'Debit Card',
      alipay: 'Alipay',
      wechat: 'WeChat Pay',
      certificateType: 'Certificate Type',
      chineseVersion: 'Chinese Version',
      chineseVersionDesc: 'Chinese content only',
      englishVersion: 'English Version',
      englishVersionDesc: 'English content only',
      termsLabel: 'Terms of Service',
      agreeTerms: 'I have read and agree to the Terms of Service',
      agreePrivacy: 'I have read and agree to the Privacy Policy',
      agreeBlockchain: 'I understand the immutability of blockchain registration and confirm the information is accurate',
      securityTitle: 'Security Guarantee:',
      securityItem1: '• All payment information is encrypted',
      securityItem2: '• 7-day no-reason refund supported (before minting)',
      securityItem3: '• Blockchain proof is permanently valid, no annual fee',
      previous: 'Previous',
      pay: 'Confirm Payment',
      processing: 'Processing...',
      submitFailed: 'Submission Failed',
      iKnow: 'Got It',
      agreeRequired: 'Please read and agree to the relevant agreements',
      uploadFileRequired: 'Submission failed, please upload a file first',
      registrationFee: 'Registration Fee',
      blockchainFee: 'Blockchain Fee',
      total: 'Total',
      paymentMethod: 'Payment Method',
      crypto: 'Cryptocurrency',
      cardNumber: 'Card Number',
      cardNumberPlaceholder: 'Enter card number',
      expiryDate: 'Expiry Date',
      expiryDatePlaceholder: 'MM/YY',
      cvv: 'CVV',
      cvvPlaceholder: 'Enter CVV',
      agree: 'I have read and agree to the',
      terms: 'Terms of Service',
      and: 'and',
      privacy: 'Privacy Policy',
    },
    complete: {
      title: 'Registration Complete',
      subtitle: 'Congratulations! Your NFT has been successfully registered',
      success: 'Registration Successful!',
      message: 'Your item has been successfully registered on the blockchain, and the NFT has been sent to your wallet address.',
      nftId: 'NFT ID',
      txHash: 'Transaction Hash',
      walletAddress: 'Wallet Address',
      viewOnBlockchain: 'View on Blockchain',
      downloadCertificate: 'Download Certificate',
      backToHome: 'Back to Home',
      viewMyNfts: 'View My NFTs'
    },
    header: {
      userCenter: 'User Center',
    },
    help: {
      title: 'Need Help?',
      desc: 'If you encounter any issues during the registration process, please check our help documentation or contact support.',
      viewDocs: 'View Help Docs',
      contactSupport: 'Contact Support',
    },
  },

  // Legal Page
  legal: {
    title: 'Legal Information',
    menuItems: {
      legal: 'Legal Terms',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      compliance: 'Compliance Statement',
      disclaimer: 'Disclaimer',
    },
    loading: 'Loading...',
    error: 'Failed to load, please try again later',
    noContent: 'No content available',
  },

  // User Center
  userCenter: {
    title: 'User Center',
    welcome: 'Welcome Back',

    sidebar: {
      dashboard: 'Dashboard',
      registrations: 'Registration Records',
      withdrawals: 'Withdrawal Records',
      orders: 'Orders & Invoices',
      notifications: 'Notifications',
      settings: 'Account Settings',
      logout: 'Logout',
      uid: 'UID',
      user: 'User',
    },

    dashboard: {
      welcome: 'Welcome Back!',
      uid: 'UID',
      loading: 'Loading...',
      quickRegister: 'Quick Register',
      batchQuery: 'Batch Query',
      stats: {
        totalRegistrations: 'Total Registrations',
        inCustody: 'In Custody',
        transferred: 'Transferred',
      },
      quickActions: {
        newRegistration: 'New Registration',
        queryVerify: 'Query & Verify',
        batchExport: 'Batch Export',
        accountSettings: 'Account Settings',
      },
      recentActivity: {
        title: 'Recent Registrations',
        viewAll: 'View All',
        noRecords: 'No registration records',
      },
      usageTips: {
        title: 'Usage Tips',
        tip1: 'Regularly back up important files to keep your digital assets safe',
        tip2: 'Use the platform custody feature and withdraw to your personal wallet anytime',
        tip3: 'Verify the authenticity and ownership of NFTs via on-chain query',
      },
      developingFeature: 'Feature coming soon...',
    },

    registrations: {
      title: 'Registration Records',
      subtitle: 'View and manage all your digital rights registration records',
      newRegistration: 'New Registration',
      filters: {
        all: 'All',
      },
      table: {
        registrationId: 'Registration ID',
        name: 'Name',
        type: 'Type',
        date: 'Date',
        status: 'Status',
        actions: 'Actions',
      },
      actions: {
        view: 'View',
        exportPdf: 'Export PDF',
        withdraw: 'Withdraw',
      },
      noData: 'No registration records',
      noDataMessage: 'No matching registration records found',
      viewAll: 'View All',
      pagination: {
        showing: 'Showing',
        to: '-',
        of: 'of',
        records: 'records',
        previous: 'Previous',
        next: 'Next',
      },
    },

    withdrawals: {
      title: 'Withdrawal Records',
      subtitle: 'View and manage your NFT withdrawal history',
      filters: {
        all: 'All',
      },
      fields: {
        tokenId: 'Token ID',
        targetWallet: 'Target Wallet',
        chainHash: 'Chain Hash',
        transactionHash: 'Transaction Hash:',
        copy: 'Copy',
      },
      viewDetails: 'View Details',
      noData: 'No data',
      noDataMessage: 'No matching withdrawal records found',
      viewAll: 'View All',
      loading: 'Loading...',
      detailModal: {
        title: 'Withdrawal Details',
        nftName: 'NFT Name',
        withdrawalId: 'Withdrawal ID',
        tokenId: 'Token ID',
        targetWallet: 'Target Wallet Address',
        withdrawalTime: 'Withdrawal Time',
        gasFee: 'Gas Fee',
        transactionHash: 'Transaction Hash',
        status: 'Status',
      },
    },

    notifications: {
      title: 'Notification Center',
      subtitle: 'You have',
      unreadCount: 'unread notifications',
      allRead: 'All notifications read',
      markAllRead: 'Mark All as Read',
      stats: {
        all: 'All Notifications',
        unread: 'Unread',
      },
      filters: {
        type: 'Type:',
        status: 'Status:',
        all: 'All',
        unread: 'Unread',
        read: 'Read',
      },
      actions: {
        markRead: 'Mark as Read',
        delete: 'Delete',
      },
      badge: {
        new: 'New',
      },
      noData: 'No notifications',
      noDataMessage: 'No matching notifications',
      loading: 'Loading...',
      pagination: {
        previous: 'Previous',
        next: 'Next',
      },
    },

    settings: {
      title: 'Account Settings',
      subtitle: 'Manage your account information and preferences',
      tabs: {
        profile: 'Profile',
        security: 'Security',
      },
      profile: {
        title: 'Profile',
        avatar: 'Avatar',
        uploadAvatar: 'Upload Avatar',
        uploading: 'Uploading...',
        uploadHint: 'Supports JPG and PNG, max file size 2MB',
        username: 'Username',
        bio: 'Bio',
        bioCount: 'chars',
        save: 'Save Changes',
        saving: 'Saving...',
      },
      security: {
        title: 'Security Settings',
        email: {
          title: 'Email Address',
          change: 'Change Email',
        },
        password: {
          title: 'Login Password',
          subtitle: 'Changing your password regularly improves account security',
          change: 'Change Password',
        },
      },
      passwordModal: {
        title: 'Change Password',
        currentPassword: 'Current Password',
        currentPasswordPlaceholder: 'Enter current password',
        newPassword: 'New Password',
        newPasswordPlaceholder: 'Enter new password',
        passwordHint: 'At least 8 characters, including letters and numbers',
        confirmPassword: 'Confirm New Password',
        confirmPasswordPlaceholder: 'Re-enter new password',
        cancel: 'Cancel',
        confirm: 'Confirm',
        changing: 'Changing...',
      },
      emailModal: {
        title: 'Change Email',
        currentEmail: 'Current Email',
        newEmail: 'New Email',
        newEmailPlaceholder: 'Enter new email address',
        verificationCode: 'Verification Code',
        verificationCodePlaceholder: 'Enter verification code',
        sendCode: 'Send Code',
        codeSent: 'Verification code sent to your new email',
        cancel: 'Cancel',
        confirm: 'Confirm',
        changing: 'Changing...',
      },
    },

    withdrawModal: {
      title: 'Withdraw NFT',
      withdrawInfo: 'Withdrawal Info',
      fields: {
        name: 'Name',
        tokenId: 'Token ID',
        registrationDate: 'Registration Date',
        targetWallet: 'Target Wallet Address',
        targetWalletPlaceholder: 'Target wallet must be on the Polygon network',
      },
      riskConfirmation: 'Risk Confirmation',
      confirmations: {
        understand: 'I understand that after withdrawal, the NFT will be transferred to the specified wallet and the platform will no longer hold it in custody',
        irreversible: 'I confirm the wallet address is correct. The withdrawal is irreversible',
      },
      warning: {
        title: 'Important Notice:',
        message: 'Please double-check the wallet address. Once the NFT is transferred, it cannot be reversed. We recommend testing with a small amount first or using a verified wallet address.',
      },
      actions: {
        cancel: 'Cancel',
        submit: 'Submit',
        submitting: 'Submitting...',
      },
      validation: {
        addressRequired: 'Please enter a wallet address',
        addressInvalid: 'Please enter a valid wallet address (42 characters starting with 0x)',
      },
    },
  },
};

export default common;
